module.exports = __webpack_public_path__ + "img/primary_4x1_z18.a8aeb92d.svg";